import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit} from "@angular/core";
import {FUIFormContext, FUIInlineFormContext} from "@fedeltapointofsale/ui";
import {AccessRoleAuthorisationData} from "../access-role.data";
import {EntityData} from "@fedeltapointofsale/data-client";

export class PrivilegeRecord {
    id: string;
    name: string;

    /**
     * bo, fo, wo
     */
    groupType: string;

    /**
     * Supported flags
     */
    supportAllow: boolean;
    supportCreate: boolean;
    supportView: boolean;
    supportUpdate: boolean;
    supportDelete: boolean;

    /**
     * Set flags
     */
    allow: boolean;
    create: boolean;
    view: boolean;
    update: boolean;
    delete: boolean;

}

@Component({
    selector: "wbo-privilege-selection",
    styleUrls: ["./privilege-selection.component.scss"],
    templateUrl: "./privilege-selection.component.html",
    providers: [{provide: FUIFormContext, useClass: FUIInlineFormContext}],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PrivilegeSelectionComponent implements OnInit {

    @Input() privileges: PrivilegeRecord[];

    @Input() authorisations: AccessRoleAuthorisationData[];

    /**
     * bo, fo, wo
     */
    @Input() groupName: string;

    constructor(private changeRef: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        this.privileges.forEach((priv: PrivilegeRecord) => {
            priv.allow = priv.supportAllow && this.containsAuth(AccessRoleAuthorisationData.createKey(priv.groupType, priv.id));
            priv.create = priv.supportCreate && this.containsAuth(AccessRoleAuthorisationData.createKey(priv.groupType, "create" + priv.id));
            priv.view = priv.supportView && this.containsAuth(AccessRoleAuthorisationData.createKey(priv.groupType, "view" + priv.id));
            priv.update = priv.supportUpdate && this.containsAuth(AccessRoleAuthorisationData.createKey(priv.groupType, "update" + priv.id));
            if (priv.supportDelete) {
                priv.delete = this.containsAuth(AccessRoleAuthorisationData.createKey(priv.groupType, "delete" + priv.id));
            }
        });

        setTimeout(() => {
            this.changeRef.detectChanges();
        });
    }

    private containsAuth(k: string): boolean {
        return this.authorisations.findIndex((a1: AccessRoleAuthorisationData) => k === a1.key) != -1;
    }


    changeAll(selected: boolean): void {

        this.privileges.forEach((priv: PrivilegeRecord) => {
            if (priv.supportAllow) {
                this.onAllowChanged(selected, priv);
            }
            if (priv.supportCreate) {
                this.onCreateChanged(selected, priv);
            }
            if (priv.supportView) {
                this.onViewChanged(selected, priv);
            }
            if (priv.supportUpdate) {
                this.onUpdateChanged(selected, priv);
            }
            if (priv.supportDelete) {
                this.onDeleteChanged(selected, priv);
            }
        });

        setTimeout(() => this.changeRef.detectChanges());
    }


    onAllowChanged(value: boolean, priv: PrivilegeRecord): void {
        this.onPrivChanged(value, priv, "");
        priv.allow = value;
    }

    onCreateChanged(value: boolean, priv: PrivilegeRecord): void {
        this.onPrivChanged(value, priv, "create");
        priv.create = value;
    }

    onViewChanged(value: boolean, priv: PrivilegeRecord): void {
        this.onPrivChanged(value, priv, "view");
        priv.view = value;
    }

    onUpdateChanged(value: boolean, priv: PrivilegeRecord): void {
        this.onPrivChanged(value, priv, "update");
        priv.update = value;
    }

    onDeleteChanged(value: boolean, priv: PrivilegeRecord): void {
        this.onPrivChanged(value, priv, "delete");
        priv.delete = value;
    }

    onPrivChanged(value: boolean, priv: PrivilegeRecord, action: string): void {
        const k: string = AccessRoleAuthorisationData.createKey(priv.groupType, action + priv.id);
        const idx: number = this.authorisations.findIndex((a1: AccessRoleAuthorisationData) => k === a1.key);

        if (value == (idx != -1)) {
            return;
        }

        if (value) {
            const a: AccessRoleAuthorisationData = <AccessRoleAuthorisationData>EntityData.create(AccessRoleAuthorisationData);
            a.name = action + priv.id;
            a.groupType = priv.groupType;
            this.authorisations.push(a);
        }
        else {
            if (idx != -1) {
                this.authorisations.splice(idx, 1);
            }
        }

    }


}
